import { render } from "./CalculatorTable.vue?vue&type=template&id=a13b845c&scoped=true"
import script from "./CalculatorTable.vue?vue&type=script&lang=js"
export * from "./CalculatorTable.vue?vue&type=script&lang=js"

import "./CalculatorTable.vue?vue&type=style&index=0&id=a13b845c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a13b845c"]])

export default __exports__